module.exports = __webpack_public_path__ + "img/tiktok logo@2x.e2f75149.png";